import { useNavigate } from "react-router";
import { useStore } from "zustand";
import { Text, SelectBoxGroup, SelectBox } from "@react-spectrum/s2";

import { store } from "@app/store";
import { useBreadcrumbs } from "@app/components/Breadcrumbs";

import AIChat from "@react-spectrum/s2/illustrations/linear/AIChat";
import FileVideo from "@react-spectrum/s2/illustrations/linear/FileVideo";
import FolderOpen from "@react-spectrum/s2/illustrations/linear/FolderOpen";
import Crop from "@react-spectrum/s2/illustrations/linear/Crop";
import AudioWave from "@react-spectrum/s2/illustrations/linear/AudioWave";
import UserGroup from "@react-spectrum/s2/illustrations/linear/UserGroup";
import Filmstrip from "@react-spectrum/s2/illustrations/linear/Filmstrip";
import DataAnalytics from "@react-spectrum/s2/illustrations/linear/DataAnalytics";

const features = [
  {
    name: "Users",
    icon: <UserGroup />,
    path: "./users",
  },
  {
    name: "Projects",
    icon: <FolderOpen />,
    path: "./projects",
  },
  {
    name: "Zoltar Prompts",
    icon: <AIChat />,
    path: "./prompts",
  },
  {
    name: "Dynamic Graphics Render",
    icon: <FileVideo />,
    path: "./mogrt",
  },
  {
    name: "Text-to-speech",
    icon: <AudioWave />,
    path: "./text-to-speech",
  },
  {
    name: "Image Crop",
    icon: <Crop />,
    path: "./image-crop",
  },
  {
    name: "FluffyJaws",
    icon: <AIChat />,
    path: "./fluffyjaws",
  },
  {
    name: "Footage",
    icon: <Filmstrip />,
    path: "./footage",
  },
  {
    name: "API Status",
    icon: <DataAnalytics />,
    path: "./integrations",
  },
];

export const AdminList = ({}) => {
  const navigate = useNavigate();

  const isMobile = useStore(store, (state) => state.isMobile);

  useBreadcrumbs([{ label: "Admin", href: "/admin" }]);

  return (
    <>
      <title>Admin tools | BeStory</title>
      <SelectBoxGroup
        aria-label="Admin tools"
        onSelectionChange={([key]) => navigate(key)}
        orientation={isMobile ? "horizontal" : "vertical"}
      >
        {features.map((feature) => (
          <SelectBox id={feature.path} key={feature.path}>
            {feature.icon}
            <Text slot="label">{feature.name}</Text>
          </SelectBox>
        ))}
      </SelectBoxGroup>
    </>
  );
};
